import { useState } from 'react';
import { withRouter } from 'react-router-dom';
import AuthLayout from '../../../components/AuthLayout';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
const { API_URL, ASSOCIATE_URL } = config;

const ForgotPassword = ({ history, match: { params } }) => {
  const type = params.type;
  const [email, setEmail] = useState('');

  const emailHandler = (e) => setEmail(e.target.value);

  const submitFormHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to reset your password?'
      )
    ) {
      try {
        let response = await fetch(
          `${API_URL}/${type}/reset-password/request`,
          {
            mode: 'cors',
            method: 'POST',
            body: JSON.stringify({ email }),
            withCredentials: true,
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json; charset=utf-8',
            },
          }
        );

        let responseData = await response.json();

        if (response.ok) {
          ToastUtil.success(responseData.message);
          if (type === 'associate') {
            window.location.href = ASSOCIATE_URL;
          } else {
            history.push('/');
          }
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <AuthLayout title="Reset your password" subtitle="Enter your email and we’ll send you recovery instructions.">
        <form className="auth-form" onSubmit={(e) => submitFormHandler(e)}>
          <label>Email address</label>
          <input
            className="form-control"
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => emailHandler(e)}
          />
          <button
            type="submit"
            className="btn btn-brand w-100"
          >
            Send
          </button>
        </form>
    </AuthLayout>
  );
};

export default withRouter(ForgotPassword);
